function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
  fill: "#FFA14A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42 115.581L86.738 115.581V128.083H56.5253L56.5253 143.976H81.3153V155.896H56.5253L56.5253 183.419H42L42 115.581Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M91.75 115.581H145.397V128.083H125.836L125.836 183.419H111.311L111.311 128.083H91.75V115.581Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M161.423 161.323C161.681 164.683 163.037 167.396 165.49 169.463C168.008 171.466 171.333 172.468 175.464 172.468C178.886 172.468 181.662 171.757 183.792 170.336C185.987 168.85 187.085 166.815 187.085 164.23C187.085 162.421 186.471 161 185.245 159.966C184.083 158.868 182.404 158.028 180.209 157.447C178.079 156.801 174.754 156.025 170.235 155.121C165.781 154.281 162.037 153.215 159.002 151.923C155.968 150.566 153.483 148.596 151.546 146.011C149.674 143.362 148.738 139.874 148.738 135.545C148.738 131.604 149.803 128.083 151.933 124.982C154.128 121.881 157.13 119.458 160.939 117.713C164.813 115.904 169.17 115 174.012 115C178.983 115 183.437 115.937 187.375 117.81C191.378 119.619 194.509 122.139 196.768 125.369C199.092 128.6 200.287 132.25 200.351 136.32H186.116C185.794 133.413 184.567 131.087 182.437 129.343C180.306 127.534 177.498 126.629 174.012 126.629C170.784 126.629 168.202 127.308 166.265 128.664C164.328 130.021 163.36 131.959 163.36 134.479C163.36 136.288 163.941 137.709 165.103 138.743C166.265 139.712 167.911 140.52 170.042 141.166C172.172 141.747 175.464 142.458 179.919 143.298C184.438 144.138 188.247 145.204 191.345 146.496C194.444 147.723 196.93 149.629 198.802 152.213C200.739 154.733 201.707 158.125 201.707 162.389C201.707 166.524 200.577 170.239 198.318 173.534C196.058 176.764 192.895 179.316 188.828 181.19C184.825 183.063 180.306 184 175.271 184C169.848 184 165.006 183.031 160.745 181.093C156.549 179.09 153.257 176.344 150.868 172.855C148.48 169.367 147.253 165.458 147.188 161.129L161.423 161.323Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M210.422 115.581L255.935 115.581V128.083L224.947 128.083V143.298L250.125 143.298V155.218L224.947 155.218V170.917L257 170.917V183.419L210.422 183.419V115.581Z",
  fill: "white"
});

var SvgFtse = function SvgFtse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFtse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FTSE.8bd8110f.svg";
export { ForwardRef as ReactComponent };